import React from 'react'
import SkeletonBlock from './SkeletonBlock'

/**
 * Availability page placeholder: 3-segment date-range toggle + a stack
 * of day-card skeletons.
 */
function AvailabilitySkeleton() {
  return (
    <div className="min-h-screen bg-app">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8">
        <div className="space-y-6">
          {/* Date range toggle */}
          <div className="flex space-x-1 bg-surface rounded-lg p-1">
            {[0, 1, 2].map((i) => (
              <SkeletonBlock key={i} className="flex-1 h-11 rounded-md" />
            ))}
          </div>
          {/* Day cards */}
          <div className="space-y-4 sm:space-y-6">
            {[0, 1, 2, 3].map((i) => (
              <div
                key={i}
                className="bg-card border border-border-subtle rounded-xl p-4 md:p-6 space-y-4"
              >
                <div className="flex items-center justify-between">
                  <SkeletonBlock className="h-4 w-32 rounded" />
                  <div className="flex gap-2">
                    <SkeletonBlock className="h-7 w-16 rounded-lg" />
                  </div>
                </div>
                <SkeletonBlock className="h-12 w-full rounded-lg" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default AvailabilitySkeleton
